<ng-content select=".title"></ng-content>
<ng-content select=".links"></ng-content>
